import React, { Fragment } from 'react'

const Modal = ({ isVisible, onCloseModal, children }) => {
    return (
        <Fragment>
            {isVisible &&
                <Fragment>
                    <div className="modal-container modal">
                        { children }
                    </div>
                    <div className="fog" onClick={() => { if (onCloseModal) onCloseModal() }} />
                </Fragment>
            }
        </Fragment>
    )
}

export { Modal }
